'use strict';

/**
 * React 19 main entry does not expose a callable `findDOMNode`. Many legacy packages
 * (react-overlays, react-bootstrap, react-transition-group) still call it on the default export.
 * Load the real react-dom implementation, then attach find-dom-node-polyfill.
 *
 * Subpaths like `react-dom/client` are not aliased and keep using node_modules/react-dom.
 */

function checkDCE() {
	/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	if (
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	) {
		return;
	}
	if (process.env.NODE_ENV !== 'production') {
		throw new Error('^_^');
	}
	try {
		__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	} catch (err) {
		console.error(err);
	}
}

if (process.env.NODE_ENV === 'production') {
	checkDCE();
	module.exports = require('../../node_modules/react-dom/cjs/react-dom.production.js');
} else {
	module.exports = require('../../node_modules/react-dom/cjs/react-dom.development.js');
}

const { findDOMNode: findDOMNodePolyfill } = require('find-dom-node-polyfill');

function findDOMNodeSafe(instance) {
	if (instance == null) {
		return null;
	}
	// Real findDOMNode returns the node unchanged; the fiber polyfill only handles React instances.
	if (typeof instance === 'object' && typeof instance.nodeType === 'number') {
		return instance;
	}
	try {
		return findDOMNodePolyfill(instance);
	} catch (e) {
		if (process.env.NODE_ENV !== 'production') {
			// Polyfill throws on bad args (e.g. Object.keys(undefined)); legacy callers expect null-ish.
			console.warn('[react-dom shim] findDOMNode:', e && e.message ? e.message : e);
		}
		return null;
	}
}

if (typeof module.exports.findDOMNode !== 'function') {
	module.exports.findDOMNode = findDOMNodeSafe;
}
